import { render } from "./SliderProducts.vue?vue&type=template&id=9b9f80c4&ts=true&lang=pug"
import script from "./SliderProducts.vue?vue&type=script&setup=true&lang=ts"
export * from "./SliderProducts.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__